import React from 'react';
import { BookOpenIcon, CloudSunIcon, GiftIcon, UsersIcon } from 'lucide-react';
const items = [{
  icon: BookOpenIcon,
  label: '9 comprehensive volumes'
}, {
  icon: GiftIcon,
  label: '5 exclusive bonuses'
}, {
  icon: CloudSunIcon,
  label: '+450 ready-to-use resources'
}, {
  icon: UsersIcon,
  label: 'Teachers, students and professionals'
}];
export function SocialProof() {
  return <section className="border-y border-silverEdge bg-navyPanel py-5" aria-label="What the teacher ready includes" data-id="element-216" data-mp="3ebld7yk3lwz">
      <div className="mx-auto flex max-w-5xl flex-wrap items-center justify-center gap-x-8 gap-y-3 px-4 text-sm font-semibold text-silver sm:justify-between" data-id="element-217" data-mp="8e7t9iadjxht">
        {items.map(({
        icon: Icon,
        label
      }) => <span key={label} className="inline-flex items-center gap-2" data-id="element-218" data-mp="3us7x4jc13qka">
            <Icon className="h-5 w-5 text-silverBright" aria-hidden="true" data-id="element-219" data-mp="md7cubj15m74" /> {label}
          </span>)}
      </div>
    </section>;
}